<h2 mat-dialog-title>Exportar Roadmap</h2>

<div mat-dialog-content>
  <form [formGroup]="formGroup" class="roadmap-export-form">
    <mat-form-field appearance="outline">
      <mat-label>Desde</mat-label>
      <input matInput [matDatepicker]="fromPicker" formControlName="from" />
      <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Hasta</mat-label>
      <input matInput [matDatepicker]="toPicker" formControlName="to" />
      <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
    </mat-form-field>

    <mat-slide-toggle formControlName="is_epics_request">Exportar por épicas</mat-slide-toggle>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="formGroup.invalid">Descargar</button>
</div>
